import * as React from "react";
import { createRoot } from "react-dom/client";
import Cookies from 'js-cookie';
import i18n from "./i18n";
import { webChatService } from './services/webchat.service';

import { Provider } from 'react-redux'
import { store } from './store/index'

import { WebChat } from "./components/web-chat";
import { WebChatSettingsDTO, WebChatDTO, WebchatPosition, WebchatLogoPosition } from './models/chat.models';
import { configuration } from "./services/configuration";

async function getActiveChat(): Promise<void>  {
  let session = Cookies.get("wch_session");
  let webChat: WebChatDTO = await webChatService.getActiveChat(session);
  
  if (webChat) {
    if (webChat.Lang) {
      i18n.changeLanguage(webChat.Lang);
    } else {
      let lang = Cookies.get("lang");
      if (lang) {
        i18n.changeLanguage(lang);
      }
    }
    Cookies.set("wch_session", webChat.Session, { expires: 1 });
    store.dispatch({ type: 'SET_WEB_CHAT', payload: webChat });
    store.dispatch({ type: 'SHOW_WELCOME_MESSAGE', payload: !webChat.ForceOpen });
    store.dispatch({ type: 'SET_WEB_CHAT_MESSAGES', payload: webChat.Ticket && webChat.Ticket && webChat.Ticket.TicketResponseMessages ? webChat.Ticket.TicketResponseMessages : [] });
  }
}

async function start(): Promise<void> {
  
  //let token = Cookies.get('token') || Cookies.get('accessToken');
  if (/*token &&*/ document && document.body) {

    const element = document.createElement('div');
    document.body.appendChild(element);
    
    let settings: WebChatSettingsDTO = await webChatService.getSettings();
    settings.IconUrl = (settings.IconUrl.startsWith('http://') || settings.IconUrl.startsWith('https://')) ? settings.IconUrl : configuration.SERVICE_URL + settings.IconUrl;
    settings.LogoUrl = (settings.LogoUrl.startsWith('http://') || settings.LogoUrl.startsWith('https://')) ? settings.LogoUrl : configuration.SERVICE_URL + settings.LogoUrl;
    settings.AssistantIconUrl = (settings.AssistantIconUrl.startsWith('http://') || settings.AssistantIconUrl.startsWith('https://')) ? settings.AssistantIconUrl : configuration.SERVICE_URL + settings.AssistantIconUrl;

    await getActiveChat();

    const root = createRoot(element);
    root.render(
      <Provider store={store}>  
        <WebChat webChatSettings={settings} />
      </Provider>
    );

    setTimeout(draggale, 0);
  }
  else {
    setTimeout(start, 1000);
  }
}

function chatbotDraggable(): void {
  document.getElementsByClassName("webchat-draggable")[0].classList.remove("dropup");
  document.getElementsByClassName("webchat-draggable")[0].classList.remove("dropleft");

  if (document.getElementsByClassName("webchat-draggable")[0].getBoundingClientRect().top < 500) {
    document.getElementsByClassName("webchat-draggable")[0].classList.add("dropup");
  }

  if (document.getElementsByClassName("webchat-draggable")[0].getBoundingClientRect().left < 310) {
    document.getElementsByClassName("webchat-draggable")[0].classList.add("dropleft");
  }
}

async function draggale(): Promise<void> {
  var div = document.getElementById('help-desk-container');

  var offset = [div.offsetLeft, div.offsetTop];
  var mousePosition;
  var isDown = false;

  div.addEventListener('drag', function (e) {
    move(e);
  });

  if (!navigator.userAgent.match(/firefox|fxios/i)) {
    div.addEventListener('dragend', function (e) {
      isDown = false;
    });
  }

  div.addEventListener('mousedown', function (e) {
    isDown = true;
    offset = [
      div.offsetLeft - e.clientX,
      div.offsetTop - e.clientY
    ];
    mousePosition = {
      x: e.clientX,
      y: e.clientY
    };
  }, true);

  div.addEventListener('mouseup', function (e) {
    isDown = false;
  }, true);
  
  document.addEventListener('mousemove', function (e) {
    if (isDown) {
      move(e);
    }
  }, true);

  function move(e) {
    let event = e || window.event;

    var previousPosition = {
      x: mousePosition.x,
      y: mousePosition.y
    };
      
    mousePosition = {
      x: event.clientX,
      y: event.clientY
    };

    if (Math.abs(mousePosition.x - previousPosition.x) < 300 && Math.abs(mousePosition.y - previousPosition.y) < 300) {
      div.style.left = (mousePosition.x + offset[0]) + 'px';
      div.style.top = (mousePosition.y + offset[1]) + 'px';
      chatbotDraggable();
    } else {
      mousePosition = {
        x: previousPosition.x,
        y: previousPosition.y
      };
    }
  }
}

setTimeout(start, 0);

